









































import { Prop, Component, Vue, Watch } from 'vue-property-decorator'
import { PipelinePhaseCategories, PipelinePhaseCategory } from '@/api/types'
import { PipelinePhase } from '@/api/model/pipeline-phase'

@Component
export default class EditPipelinePhaseForm extends Vue {
    @Prop() readonly pipelinePhase!: PipelinePhase
    @Prop() readonly takenPipelinePhaseColors!: string[]
    @Prop({ default: false }) readonly inUse!: boolean

    value: PipelinePhase = null

    mounted() {
        this.setValue()
    }

    @Watch('pipelinePhase')
    setValue() {
        if (!this.pipelinePhase) {
            return
        }

        this.value = this.pipelinePhase.clone()
    }

    get options(): Array<{label: string|null, value: string|number}> {
        return PipelinePhaseCategories.map((pipelinePhaseCategory: PipelinePhaseCategory) => {
            return {
                label: this.$t('pipeline-phase.category.' + pipelinePhaseCategory).toString(),
                value: pipelinePhaseCategory,
            }
        })
    }

    get colorOptions(): string[] {
        return [
            '#ED6906',
            '#FFCB00',
            '#43B072',
            '#4075BA',
            '#545CA6',
            '#E9408F',
            '#E7305E',
            '#A0549C',
            '#4C438E',
            '#00A3DF',
            '#00A677',
            '#74B72B',
            '#A41916',
            '#06111A',
        ]
    }

    get otherTakenPipelinePhaseColors(): string[] {
        return this.takenPipelinePhaseColors.filter(color => color !== this.pipelinePhase.color)
    }

    get isValid(): boolean {
        const array = [undefined, null, '']
        return !array.includes(this.value.name)
            && PipelinePhaseCategories.includes(this.value.category) && this.value.color !== '#000000'
            && !this.nameContainsForbiddenValue
    }

    get nameContainsForbiddenValue(): boolean {
        return [
            'kans',
            'gewonnen',
            'verloren',
            'lopend',
        ].includes(this.value.name.toLowerCase())
    }
}
